import {ComponentType, FC} from 'react';
import {ErrorBoundary as RollbarErrorBoundary} from '@rollbar/react';

import {getConfig} from "../../_configs/AppConfig";
const {publicRuntimeConfig} = getConfig();

export const rollbarConfig = {
    accessToken: publicRuntimeConfig.rollbar.post_client_access_token,
    environment: publicRuntimeConfig.APP_ENV,
    captureUncaught: true,
    captureUnhandledRejections: true,
    enabled: publicRuntimeConfig.APP_ENV !== "dev",
    ignoredMessages: [
        /ChunkLoadError: Loading chunk [0-9]* failed/,
        /SyntaxError: Unexpected EOF/,
        /Uncaught SyntaxError: Unexpected token '<'/,
    ],
    payload: {
        person: {},
        client: {
            javascript: {
                code_version: publicRuntimeConfig.REACT_FRONTEND_VERSION,
            }
        }
    }
}

const DefaultFallbackUI = ({ error, resetError }) => {
    if (publicRuntimeConfig.APP_ENV === "dev") {
        console.error('error: ', error);
        console.error('resetError: ', resetError);
    }
    return <div className="sb-error-inside-block" style={{padding: "1rem"}}>
        <span className="sb-error-inside-block-icon far fa-frown"/>
        <div className="sb-error-inside-block-header"><h2>Oops, there was an error!</h2></div>
        <p className="sb-error-inside-block-message">
            Don't worry, we're on it.  The error has been logged and we'll work hard to fix it.
        </p>
    </div>
}

export const ErrorBoundary: FC<{
    fallbackUI?: ComponentType<{ error: string }>
    userGenerated?: boolean,
}> = (props) => {
    const extra = {
        user_generated: props.userGenerated ? "true" : "false",
    }

    return <RollbarErrorBoundary fallbackUI={props.fallbackUI || DefaultFallbackUI} extra={extra}>
        {props.children}
    </RollbarErrorBoundary>
}
